import { combineReducers, configureStore } from "@reduxjs/toolkit";
import sessionSlice from "./session/sessionSlice";
import userDataSlice from "./user/userDataSlice";
import dashboardSlice from "./dashboard/dashboardSlice";
import workstationsListSlice from "./workstationsListSlice/workstationsListSlice";
import checklistsSlice from "./checklists/checklistsSlice";
import trackingSlices from "./tracking/trackingSlice";
import trazabilitySlice from "./trazability/trazabilitySlice";

const rootReducer = combineReducers({
  session: sessionSlice,
  userData: userDataSlice,
  dashboard: dashboardSlice,
  workstationsList: workstationsListSlice,
  checklists: checklistsSlice,
  tracking: trackingSlices,
  trazability: trazabilitySlice
});

export const setupStore = preloadedState => {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
};
